import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import "rxjs/add/observable/of";
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Observable";
import { TmSemafoneConfig } from '../model/semafone-config';



export class SemafoneConfig  {

    constructor(protected http: Http) {
    }

    /** @description get semafone config information
    *   @return {string}
    */
    private apiUrl = "/api/semafone/config";
    get(): Observable<TmSemafoneConfig> {
        return this.http
            .get(this.apiUrl)
            .map((r: Response) => r.json() as TmSemafoneConfig);
    }
static ctorParameters() { return [ { type: Http } ]; }}






// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../tscapi/service/config.service.ts